import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { getContactQuickConnectByUid } from "../Service/contactApi";
import { useNavigate } from "react-router-dom";
import TypedText from "components/Homes/typewrite";
import { API_BASE_CMS } from "helper/environment";
import ReCAPTCHA from "react-google-recaptcha";
const UUID = "c426123b-42c5-4fa4-b547-610c058c052b";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const Contact: React.FC = () => {
  const navigate = useNavigate();

  const [data, setData] = useState<any>(null);

  const siteKey= localStorage.getItem("siteKey");
  //console.log(siteKey);
  // Fetch Quick Connect data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getContactQuickConnectByUid(UUID);
        setData(result);
      } catch (err) {
        console.error("Quick connect error:", err);
      }
    };
    fetchData();
  }, []);
const title = data?.mainTitle ? data?.mainTitle?.replace(/<[^>]*>/g, "")  : "Contact";
const fullNameField = data?.formfield?.find((f: any) => f.name === "full_name");

const emailField = data?.formfield?.find((f: any) => f.name === "emailid");

const mobileField = data?.formfield?.find((f: any) => f.name === "mobile");

const subjectField = data?.formfield?.find((f: any) => f.name === "subject");

const messageField = data?.formfield?.find((f: any) => f.name === "message");
 const [captchaToken, setCaptchaToken] = useState("");
const recaptchaRef = useRef<any>(null);
const [loading, setLoading] = useState(false);
const [error, setError] = useState("");
const [errors, setErrors] = useState({
  name: "",
  email: "",
  mobile: "",
  subject: "",
  message: "",
  captcha:"",
});
  const [success, setSuccess] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  
  });

const validateForm = () => {
  const newErrors = {
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
     captcha:"",
  };

  if (!formData.name.trim()) {
    newErrors.name = "Please enter your Full Name";
  } else if (!/^[A-Za-z\s]+$/.test(formData.name) ) {
    newErrors.name = "Please enter valid Full Name";
  } 
  // else if ( formData.name.length <= 5) {
  //   newErrors.name = "Please enter valid Full Name.";
  // }

  if (!formData.email.trim()) {
    newErrors.email = "Please enter your Email Address";
  } else if (
    !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(formData.email)
  ) {
    newErrors.email = "Please enter a valid Email Address ex.abc@gmail.com";
  }

  if (!formData.mobile.trim()) {
    newErrors.mobile = "Please enter your Mobile Number";
  } else if (!/^[6-9][0-9]{9}$/.test(formData.mobile)) {
    newErrors.mobile = "Mobile Number must be exactly 10 digits";
  }

  if (!formData.subject.trim()) {
    newErrors.subject = "Please enter a Subject";
  } 
  // else if (formData.subject.length < 5) {
  // newErrors.subject = "Subject must be less than 5 characters or above";
  // }

  if (!formData.message.trim()) {
    newErrors.message = "Please enter the Message";
  } else if (formData.message.length > 500) {
    newErrors.message = "Maximum 500 characters allowed. You have entered " + formData.message.length;
  }
    if (!captchaToken) {
     newErrors.captcha="Please verify that you are not a robot.";
     
    }

  setErrors(newErrors);

  return Object.values(newErrors).every((error) => error === "");
};
const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  setSuccess("");
  setErrors({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
    captcha:"",
  });

  const isValid = validateForm();

  if (!isValid) return;

  setLoading(true);

  try {
    const payload = {
      // webform_id: "contact",
      // name: formData.name,
      // email: formData.email,
      // subject: formData.subject,
      // mobile: "+91 " + formData.mobile,
      // message: formData.message,
      // g-recaptcha-response: captchaToken

      "webform_id": "contact",
      "name": formData.name,
      "email":formData.email,
      "subject": formData.subject,
      "mobile": "+91 " + formData.mobile,
      "message":formData.message,
      "g-recaptcha-response": captchaToken
    };

    // const response = await axios.post(
    //   {API_BASE_CMS}+"webform_rest/submit",
    //   payload
    // );
    // const response = await axios.post(
    //   "/drupal/webform_rest/submit",
    //   payload
    // );
    
  const response = await fetch( `${API_BASE_CMS}/webform_rest/submit`, {
    method: "POST",
    headers: {
       "Content-Type": "application/json",
    },
   body: JSON.stringify(payload)
  });

    if (response.status === 200 || response.status === 201) {
     // setSuccess("Form submitted successfully!");
     navigate('/thank-you');
      setFormData({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
      });

      setErrors({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
        captcha:"",
      });
       recaptchaRef.current.reset();
  setCaptchaToken("");
    }
  } catch (err: any) {
    setError("Submission failed");
  } finally {
    setLoading(false);
  }
};
 

  const handleCaptcha = (token:any) => {
     
    setCaptchaToken(token);
  };
const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  const { name, value } = e.target;
  if (name === "mobile") {
      // allow empty (so user can delete)
      if (value === "") {
        setFormData((prev) => ({ ...prev, mobile: value }));
        return;
      }

      // allow only digits
      if (!/^\d*$/.test(value)) return;

      // max 10 digits
      if (value.length > 10) return;

      // first digit must be 6-9 (only when length >= 1)
      if (value.length >= 1 && !/^[6-9]/.test(value)) return;
    }
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  // optional: clear error while typing
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};
  if (!data) return null;
  return (
    <>
      <section className="py-3 px-lg-0">
        <div className="container px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div className="col-lg-12 text-center">
              <div className="section-title text-center mx-auto clearfix" data-wow-delay="0.2s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
                <h2>
                 {title} <span >{data.subTitle ?? ""}</span> 
                   {/* <TypedText
                index={1}
                text={`<span style="color:#000">${title}</span> ${data.subTitle ?? ""}`}
                delay={100}
                cursor="|"
              />   */}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

  <div id="section-contact" className="section-contact bg-light  section">
        <div className="container py-3">
          <div className="row ">
                <div className="col-lg-7 col-md-12 col-sm-12 co-12 mb-4" data-wow-delay="0.5s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
              <h4 className="text-primary mb-4">{data.formTitle || "Business Enquiry"}</h4>

              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                    {/* {error && (
                      <div className="alert alert-danger">{error}</div>
                    )}

                    {success && (
                      <div className="alert alert-success">{success}</div>
                    )} */}
                   <div className="col-md-6">
                        <div className="form-label">
                            <label htmlFor="name">{fullNameField.value} <span className="mandatory text-danger">*</span></label>
                            <input type="text" className="form-control" name="name" id="name"
                                placeholder={fullNameField.placeholder} 
                                 value={formData.name}  onChange={handleChange}
                              />
                            <small className="text-danger error" id="nameError"></small>
                            {errors.name && (
                              <small className="text-danger error" id="nameError">{errors.name}</small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-label">
                            <label htmlFor="email">{emailField.value} <span className="mandatory text-danger">*</span></label>
                            <input type="text" className="form-control" name="email" id="email"
                                placeholder={emailField.placeholder}  value={formData.email}  onChange={handleChange} />
                           {errors.email && (
                              <small className="text-danger error" id="nameError">{errors.email}</small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-label ">
                            <label htmlFor="mobile">{mobileField.value} <span className="mandatory text-danger">*</span></label>
                            <div className="d-flex">
                                <span className="input-group-text nocode">+91</span>
                                <input type="number" className="form-control nocode-form-control" name="mobile"
                                    id="mobile" placeholder={mobileField.placeholder} 
                                    title="Enter exactly 10 digits"  value={formData.mobile}  onChange={handleChange}  />

                            </div>
                              {errors.mobile && (
                              <small className="text-danger error" id="nameError">{errors.mobile}</small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-label">
                            <label htmlFor="subject">{subjectField.value} <span className="mandatory text-danger">*</span></label>

                            <input type="text" className="form-control" name="subject" id="subject"
                                placeholder={subjectField.placeholder}   value={formData.subject}  onChange={handleChange}  />
                           {errors.subject && (
                              <small className="text-danger error" id="nameError">{errors.subject}</small>
                            )}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-label">
                            <label htmlFor="message">{messageField.value} <span className="mandatory text-danger">*</span></label>


                            <textarea className="form-control" placeholder={messageField.placeholder} name="message"
                                id="message" style={{height: '100px'}}  value={formData.message}  onChange={handleChange} />
                           
                            <small id="wordCount" className="text-muted me-2">
                                {formData.message.length} / 500
                              </small>

                              {errors.message && (
                                <small className="text-danger error">
                                  {errors.message}
                                </small>
                              )}
                            </div>
                    </div>
                    <div className="col-12">
                      <div className="form-label">
                      <ReCAPTCHA
                      ref={recaptchaRef}
                            sitekey={siteKey || ""}
                            onChange={handleCaptcha}
                          />
                            {errors.captcha && (
                                <small className="text-danger error">
                                  {errors.captcha}
                                </small>
                              )}
                          </div>
                      </div>
                

                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary rounded-pill px-5"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : data?.formbutton || "submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* RIGHT COLUMN — QUICK CONNECT */}
             <div className=" col-lg-5 col-md-12 col-sm-12 co-12 mb-4 " data-wow-delay="0.8s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
             <div className="address-detail rounded-3">
                {data ? (
                  <>
                    <div
                      dangerouslySetInnerHTML={{ __html: data.quickConnectHeader }}
                    />
                    {data.items.map((item: any, idx: number) => (
                      <a href={item.iconClass.uri} key={idx} target="_blank" className="d-flex">
                        <i className={item.iconClass.title} style={{fontSize:'18px'}}></i>
                        <span className="ps-4" dangerouslySetInnerHTML={{  __html: item.text || ""  }} />
                      </a>
                    ))}
                  </>
                ) : (
                  <p>...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
